export default "__VITE_ASSET__5Y50k2iK__"